module.exports = __webpack_public_path__ + "img/KG.d786536b.svg";